import { authClient, API } from "../index";

// Count all modalidades
export const countModalidades = () => {
  return authClient().get(`${API}/modalidad/count`);
};

// Get all modalidades
export const getModalidades = () => {
  return authClient().get(`${API}/modalidad`);
};

// Get modalidad by id
export const getModalidadById = (id) => {
  return authClient().get(`${API}/modalidad/${id}`);
};

// Update modalidad
export const updateModalidad = (id, modalidad) => {
  return authClient().put(`${API}/modalidad/${id}`, modalidad);
};

// Create modalidad
export const postModalidad = (modalidad) => {
  return authClient().post(`${API}/modalidad`, modalidad);
};

// Delete modalidad
export const deleteModalidad = (id) => {
  return authClient().delete(`${API}/modalidad/${id}`);
};

// Change status modalidad
export const changeStatusModalidad = async (id, active) => {
  return authClient().put(`${API}/modalidad/change-status/${id}`, { active });
};
